<template>
    <div>
        <div :class="item.name ? 'info-box' : 'empty'" @click="detail(item)">
            <div class="name">
                <slot name="name-slot"></slot>
            </div>
            <div class="title">
                <slot name="title-slot"></slot>
            </div>
            <!-- <div class="title">{{ item.title }}</div> -->
        </div>
        <transition name="customer-fade" appear>
            <div v-show="show && !ban" class="detail" @click="show = false">
                <div class="info-box-in" @click.stop="">
                    <div class="name"><slot name="name-slot"></slot></div>
                    <div class="title"><slot name="title-des-slot"></slot></div>
                    <div class="line"></div>
                    <div class="content ck-content">
                        <slot name="des-slot"></slot>
                    </div>
                    <img class="close" src="@/assets/images/investorRelation/close.png" alt="close" loading="lazy" @click="show = false" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'InfoBoxComponent',
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ban: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: false
        }
    },
    computed: {},
    methods: {
        detail(item) {
            if (item.name) {
                this.show = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.empty {
    background: transparent;
    padding: 0.3rem 0.26rem;
    position: relative;
    width: 2.94rem;
}
.info-box {
    background: #f5f5f5;
    padding: 35px 40px;
    position: relative;
    width: 325px;
    border-radius: 0.18rem;
    border-top-right-radius: 0;
    margin-bottom: 20px;
    cursor: pointer;
    &::after {
        content: ' ';
        position: absolute;
        right: 0;
        top: 0;
        background: $red;
        width: 1.8px;
        height: 92px;
    }
    .name {
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;

        color: #333333;

        margin-bottom: 12px;
        white-space: pre-wrap;
    }
    .title {
        font-weight: 400;
        font-size: 24px;

        color: #333333;

        white-space: pre-wrap;
    }
}
.detail {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99;
    .info-box-in {
        background: #fff;
        padding: 40px 48px;
        position: relative;
        width: 670px;
        border-radius: 0.18rem;
        border-top-right-radius: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: scale(1, 1) translate(-50%, -50%);
        transform-origin: 0 0;
        height: 350px;
        &::after {
            content: ' ';
            position: absolute;
            left: 0;
            top: 48px;
            background: $red;
            width: 3px;
            height: 72px;
        }
        .name {
            font-weight: 500;
            font-size: 32px;

            color: #333333;
            margin-bottom: 10px;
            white-space: pre-wrap;
        }
        .title {
            font-weight: 400;
            font-size: 24px;

            color: #333333;
            white-space: pre-wrap;
        }
        .line {
            width: 100%;
            height: 1px;
            background: #dddddd;
            margin: 36px 0 32px 0;
        }
        .close {
            position: absolute;
            top: 36px;
            right: 36px;
            width: 40px;
            cursor: pointer;
        }
        .content {
            font-weight: 400;
            font-size: 0.16rem;
            color: #333333;
            white-space: pre-wrap;
            height: 108px;
            overflow-y: auto;
        }
    }
}

.customer-fade-enter-active,
.customer-fade-leave-active {
    transition: opacity 0.4s ease-in-out;
    .info-box-in {
        transition: transform 0.35s ease-in-out;
    }
}
.customer-fade-enter,
.customer-fade-leave-active {
    opacity: 0;
    .info-box-in {
        transform: scale(0.4, 0.4) translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/components/info-box.vue